import UtilsFael from '@lib/utilsFael'
import Axios from 'axios'
import qs from 'qs'

const UnidadeVirtual = 'Unidade Virtual'
const FaelInterativa = 'UniFael Interativa'

export default class Polo {
	constructor(polo = {}, cidade = '') {
		this.original = polo
		this.cidade = cidade
		this.marker = null
	}

	isUnidadeVirtual() {
		return this.original.TipoUnidade.toUpperCase() == UnidadeVirtual.toUpperCase()
	}

	isFaelInterativa() {
		return this.original.TipoUnidade.toUpperCase() == FaelInterativa.toUpperCase()
	}

	async getLatLng() {
		let params = {
			address: `${this.rua} - ${this.bairro} CEP: ${this.cep}`,
			key: UtilsFael.google_maps_api
		}
		await Axios
		.get(`https://maps.googleapis.com/maps/api/geocode/json?${qs.stringify(params)}`)
		.then(response => {
			if (response.data.results.length) {
				this.latLng = response.data.results[0].geometry.location
				setTimeout(() => this.onLoad(), 500)
			}
		})
	}

	/**
	 * @returns {object}
	 */
	get interativa() {
		let regexUnidade = new RegExp(`(?<=${this.uf.toUpperCase()}\\W{3}${UtilsFael.slugify(this.cidade, ' ').toUpperCase()}\\s)(.*)`, 'gi')
		let regexCidade = new RegExp(`(?<=\\W{3})(.*)(?=\\s-)`, 'gi')
		let regexUF = new RegExp(`^(.{2})(?=\\W{3})`, 'gi')
		return {
			endereco: this.original.EnderecoInterativa,
			rua: this.original.RuaInterativa,
			bairro: this.original.BairroInterativa,
			cep: this.original.CepInterativa,
			email: this.original.EmailInterativa,
			telefone: this.original.FoneInterativa,
			telefoneAlternativo: this.original.FoneInterativaAlternativo,
			id: this.original.IdPoloInterativa,
			cidade: (() => {
				let cidade = regexCidade.exec(this.original.NomeInterativa)
				return cidade && cidade.length ? cidade[0].trim() : ''
			})(),
			uf: (() => {
				let uf = regexUF.exec(this.original.NomeInterativa)
				return uf && uf.length ? uf[0].trim() : ''
			})(),
			unidade: (() => {
				let nome = regexUnidade.exec(this.original.NomeInterativa)
				return nome && nome.length ? nome[0].replace(/^[-\s]{1,3}/gi, '') : ''
			})()
		}
	}

	/**
	 * @returns {string}
	 */
	get endereco() {
		return this.original.Endereco ? this.original.Endereco : this.original.EnderecoInterativa
	}

	/**
	 * @returns {string}
	 */
	get email() {
		return this.original.Email ? this.original.Email : this.original.EmailInterativa
	}

	/**
	 * @returns {string}
	 */
	get telefone() {
		return this.original.Fone ? this.original.Fone : this.original.FoneInterativa
	}

	/**
	 * @returns {string}
	 */
	get telefoneAlternativo() {
		return this.original.FoneAlternativo ? this.original.FoneAlternativo : this.original.FoneInterativaAlternativo
	}

	/**
	 * @returns {string}
	 */
	get rua() {
		return this.original.Rua ? this.original.Rua : this.original.RuaInterativa
	}

	/**
	 * @returns {string}
	 */
	// get cidade () {
	//     let regex = new RegExp(`(?<=\\W{3})(.*)(?=\\s-)`, 'gi')
	//     let cidade = regex.exec(this.original.NomeUnidade)
	//     return cidade && cidade.length ? cidade[0].trim() : ''
	// }

	/**
	 * @returns {string}
	 */
	get uf() {
		let regex = new RegExp(`^(.{2})(?=\\W{3})`, 'gi')
		let uf = regex.exec(this.original.NomeUnidade)
		return uf && uf.length ? uf[0].trim() : ''
	}

	/**
	 * @returns {string}
	 */
	get id() {
		return this.original.IdPolo ? this.original.IdPolo : this.original.IdPoloInterativa
	}

	/**
	 * @returns {string}
	 */
	get nome() {
		return this.original.Nome ? this.original.Nome : this.original.NomeInterativa
	}

	/**
	 * @returns {string}
	 */
	get bairro() {
		return this.original.Bairro ? this.original.Bairro : this.original.BairroInterativa
	}

	/**
	 * @returns {string}
	 */
	get cep() {
		return this.original.Cep ? this.original.Cep : this.original.CepInterativa
	}

	/**
	 * @returns {string}
	 */
	get complemento() {
		return this.original.Complemento
	}

	/**
	 * @returns {string}
	 */
	get cidadeId() {
		return this.original.IdCidade
	}

	/**
	 * @returns {string}
	 */
	get tipo() {
		return this.original.TipoUnidade
	}

	/**
	 * @returns {string}
	 */
	get unidade() {
		if (this.isUnidadeVirtual()) {
			return this.original.NomeInterativa;
		} else {
			return this.original.NomeUnidade
		}
	}

	/**
	 * @returns {string}
	 */
	get latLng() {
		if (!this.original.latitude) {
			let alberto = "triste";
			return {
				lat: this.original.latitude || null,
				lng: this.original.longitude || null,
				alberto: alberto
			}
		}
		return {
			lat: this.original.latitude || null,
			lng: this.original.longitude || null
		}
	}
}

export const GOOGLEMAPS_STYLES = [
	{
		"featureType": "landscape",
		"elementType": "all",
		"stylers": [
			{
				"hue": "#00ff68"
			},
			{
				"saturation": -11
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
			{
				"saturation": -78
			},
			{
				"hue": "#00ff68"
			},
			{
				"lightness": -47
			},
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [
			{
				"saturation": -79
			},
			{
				"hue": "#00ff68"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#1a6137"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#e78726"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"saturation": "-100"
			},
			{
				"color": "#1a6137"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1.00"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "all",
		"stylers": [
			{
				"lightness": 30
			},
			{
				"weight": 1.3
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#e78726"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"weight": "1.00"
			},
			{
				"saturation": "0"
			},
			{
				"lightness": "0"
			},
			{
				"color": "#1a6137"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "simplified"
			},
			{
				"hue": "#00ff68"
			},
			{
				"saturation": -16
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "all",
		"stylers": [
			{
				"saturation": -72
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [
			{
				"saturation": -65
			},
			{
				"hue": "#00ff68"
			},
			{
				"lightness": 8
			}
		]
	}
]
